import { Subject } from "rxjs";

import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { CHANNEL_CLIENT_SERVICE, IClientActionService } from "../IClientActionService";
import { CubiqWorker } from "../../worker/CubiqWorker";
import {
  PRIMITIVE,
  ServiceMessageBroker,
  ServiceMessageBrokerFactory,
} from "shared/provider-webworker";
import { ClientActionPromiseService } from "./ClientActionPromiseService";
import { Injectable } from "@angular/core";
import { NotificationMethod, Long } from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class ClientActionPrimaryService extends ClientActionPromiseService {
  protected broker: ServiceMessageBroker;

  constructor(private worker: CubiqWorker, protected factory: ServiceMessageBrokerFactory) {
    super();

    this.broker = factory.createMessageBroker(CHANNEL_CLIENT_SERVICE, true, true);

    this.broker.registerMethod(
      "updateClientComments",
      [PRIMITIVE, PRIMITIVE, PRIMITIVE],
      this.updateClientComments.bind(this),
      PRIMITIVE,
    );
    this.broker.registerMethod(
      "saveClientContact",
      [
        PRIMITIVE,
        PRIMITIVE,
        PRIMITIVE,
        PRIMITIVE,
        PRIMITIVE,
        PRIMITIVE,
        PRIMITIVE,
        PRIMITIVE,
        PRIMITIVE,
        PRIMITIVE,
        PRIMITIVE,
        PRIMITIVE,
        PRIMITIVE,
      ],
      this.saveClientContact.bind(this),
      PRIMITIVE,
    );
    this.broker.registerMethod(
      "deleteClientContact",
      [PRIMITIVE],
      this.deleteClientContact.bind(this),
      PRIMITIVE,
    );
    this.broker.registerMethod(
      "saveClientTrader",
      [PRIMITIVE, PRIMITIVE, PRIMITIVE, PRIMITIVE, PRIMITIVE, PRIMITIVE, PRIMITIVE, PRIMITIVE],
      this.saveClientTrader.bind(this),
      PRIMITIVE,
    );
    this.broker.registerMethod(
      "deleteClientTrader",
      [PRIMITIVE, PRIMITIVE],
      this.deleteClientTrader.bind(this),
      PRIMITIVE,
    );
  }

  updateClientComments(
    clientCode: string,
    clientComment: string,
    privateComment: string,
  ): Promise<void> {
    let updateClientCommentsRequest: CubiqTS.UpdateClientCommentsRequestImpl =
      new CubiqTS.UpdateClientCommentsRequestImpl();

    updateClientCommentsRequest.clientCode = clientCode;
    updateClientCommentsRequest.clientComment = clientComment;
    updateClientCommentsRequest.privateComment = privateComment;

    return this.worker.postServiceRequest(updateClientCommentsRequest);
  }

  saveClientContact(
    id: string,
    clientCd: string,
    contactName: string,
    desk: string,
    mobile: string,
    sms: string,
    email: string,
    isDefault: boolean,
    notifyEntry: NotificationMethod,
    notifyExpiry: NotificationMethod,
    notifyFill: NotificationMethod,
    notifyModify: NotificationMethod,
    notifyCancel: NotificationMethod,
  ): Promise<void> {
    let clientContactUpdateRequest: CubiqTS.ClientContactUpdateRequestImpl =
      new CubiqTS.ClientContactUpdateRequestImpl();

    clientContactUpdateRequest.clientContactId = id != null ? Long.fromString(id) : null;
    clientContactUpdateRequest.clientCode = clientCd;
    clientContactUpdateRequest.contactName = contactName;
    clientContactUpdateRequest.desk = desk;
    clientContactUpdateRequest.email = email;
    clientContactUpdateRequest.mobile = mobile;
    clientContactUpdateRequest.sms = sms;
    clientContactUpdateRequest.isDefault = isDefault;
    clientContactUpdateRequest.notifyEntry = notifyEntry;
    clientContactUpdateRequest.notifyExpiry = notifyExpiry;
    clientContactUpdateRequest.notifyFill = notifyFill;
    clientContactUpdateRequest.notifyModify = notifyModify;
    clientContactUpdateRequest.notifyCancel = notifyCancel;

    return this.worker.postServiceRequest(clientContactUpdateRequest);
  }

  deleteClientContact(clientContactId: string): Promise<void> {
    let clientContactDeleteRequest: CubiqTS.ClientContactDeleteRequestImpl =
      new CubiqTS.ClientContactDeleteRequestImpl();

    clientContactDeleteRequest.clientContactId = CubiqTS.Long.fromString(clientContactId);

    return this.worker.postServiceRequest(clientContactDeleteRequest);
  }

  saveClientTrader(
    clientCode: string,
    comment: string,
    userName: string,
    userCode: string,
    desk: string,
    mobile: string,
    email: string,
    isDefault: boolean,
  ): Promise<void> {
    let saveClientTraderRequest: CubiqTS.ClientTraderUpdateRequestImpl =
      new CubiqTS.ClientTraderUpdateRequestImpl();

    saveClientTraderRequest.clientCode = clientCode;
    saveClientTraderRequest.comment = comment;
    saveClientTraderRequest.userName = userName;
    saveClientTraderRequest.userCode = userCode;
    saveClientTraderRequest.desk = desk;
    saveClientTraderRequest.mobile = mobile;
    saveClientTraderRequest.email = email;
    saveClientTraderRequest.isDefault = isDefault;

    return this.worker.postServiceRequest(saveClientTraderRequest);
  }

  deleteClientTrader(clientCode: string, userName: string): Promise<void> {
    let deleteClientTraderRequest: CubiqTS.ClientTraderDeleteRequestImpl =
      new CubiqTS.ClientTraderDeleteRequestImpl();

    deleteClientTraderRequest.clientCode = clientCode;
    deleteClientTraderRequest.userName = userName;

    return this.worker.postServiceRequest(deleteClientTraderRequest);
  }
}
